import { createReducer, on } from '@ngrx/store';
import { logoutSuccess } from 'src/app/core/store/user/user.actions';
import * as FuelActions from './fuel.actions';
import { initialState } from './fuel.state';

export const fuelReducer = createReducer(
  initialState,

  on(logoutSuccess, () => initialState),

  // Load Fuel Data
  on(FuelActions.loadFuelEntries, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(FuelActions.loadFuelEntriesSuccess, (state, { data }) => ({
    ...state,
    data,
    loading: false,
    error: null,
  })),

  on(FuelActions.loadFuelEntriesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(FuelActions.saveFuelEntries, (state, { entries }) => ({
    ...state,
    data: { entries },
    loading: true,
    error: null,
  })),

  on(FuelActions.saveFuelEntriesSuccess, (state) => ({
    ...state,
    loading: false,
    error: null,
  })),

  on(FuelActions.saveFuelEntriesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
